type Props = {
  active: string;
  onChange: (key: string) => void;
};

const TABS = [
  { key: "all", label: "综合榜", icon: "ri-list-check-2" },
  { key: "hot", label: "热度榜", icon: "ri-fire-line" },
  { key: "rating", label: "口碑榜", icon: "ri-award-line" },
  { key: "new", label: "新剧榜", icon: "ri-live-line" },
];

export default function RankingTabs({ active, onChange }: Props) {
  return (
    <div
      className="flex flex-wrap gap-1 rounded-full border border-background-200/70 bg-background-100/70 p-1"
      role="tablist"
      aria-label="榜单类型"
    >
      {TABS.map((tab) => {
        const isActive = active === tab.key;
        return (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(tab.key)}
            className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm font-label transition-colors cursor-pointer ${
              isActive
                ? "bg-primary-500 text-background-950"
                : "text-foreground-700 hover:bg-background-200"
            }`}
          >
            <i className={`${tab.icon} text-base`} aria-hidden="true"></i>
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}